import '../../shared/js/utils/polyfills';
import { initProductVariationSelects } from './sections/product/product-variation-selects';
import { initSimilarProductsCarousel } from './sections/product/product-carousel';
import { AmountSelector } from './components/amount-selector';
import { initZoom } from './components/zoom';
import { RTJS_lightbox } from '@rtsoft/rtjs';
import { fireGtmEvent, getGtmConfigData } from './gtm/gtm';
// import { renderLightBox } from './react/lightbox/lightbox'

const initStarRatingInput = (scope) => {
    const scopePrefix = typeof scope === 'undefined' ? '' : scope + ' ';

    const ratingElement = document.querySelector(scopePrefix + '#productStarRating');

    if (ratingElement === null) {
        return;
    }

    const boundInput = document.getElementById('productStarRatingInput');

    new AmountSelector(document.getElementById('productStarRating'), {
        step: 1,
        max: 10,
        onChange: function (value) {
            boundInput.value = value;
        },
        value: parseInt(boundInput.value),
    }).render();
};

document.addEventListener('DOMContentLoaded', () => {
    initSimilarProductsCarousel();

    // initProductGallery();

    initProductVariationSelects();

    initZoom();

    RTJS_lightbox('[data-rt-lightbox-gallery="productGallery"]', {
        closeLabel: ' ',
        onOpened: () => {
            const title = document.querySelector('.rt-lightbox__title');
            const text = title.querySelector('span')
                ? title.querySelector('span').innerText.replace('(', '').replace(')', '')
                : null;
            const thumbnails = document.querySelector('.rt-lightbox__thumbnails');

            if (text) {
                const newTitle = document.createElement('div');

                newTitle.innerHTML = text;
                title.appendChild(newTitle);
                title.parentElement.style.display = 'initial';
            } else {
                title.parentElement.style.display = 'none';
            }

            if (thumbnails) {
                document.getElementById('rt-lightbox-container').classList.add('rt-lightbox--with-thumbnails');
            }
        },
        onItemChanged: () => {
            const title = document.querySelector('.rt-lightbox__title');
            const text = title.querySelector('span')
                ? title.querySelector('span').innerText.replace('(', '').replace(')', '')
                : null;

            if (text) {
                const newTitle = document.createElement('div');

                newTitle.innerHTML = text;
                title.appendChild(newTitle);
                title.parentElement.style.display = 'initial';
            } else {
                title.parentElement.style.display = 'none';
            }
        },
        onClosed: () => {
            document.getElementById('rt-lightbox-container').classList.remove('rt-lightbox--with-thumbnails');
        },
    });

    naja.snippetHandler.addEventListener('afterUpdate', (event) => {
        if (
            event.detail.snippet.id === 'snippet--detailReviewModal' ||
            event.detail.snippet.id === 'snippet-productReviewModal-modalBody'
        ) {
            const snippetId = `#${event.detail.snippet.id}`;

            initStarRatingInput(snippetId);
        }
    });

    if (getGtmConfigData().enabled) {
        // Pri ajaxu kontrolujeme, jestli neprisla gtmData (pro odeslane hodnoceni)
        naja.addEventListener('success', (event) => {
            const gtmData = event.detail.payload.gtmEventData;

            if (typeof gtmData !== 'undefined') {
                fireGtmEvent(JSON.parse(gtmData));
            }
        });
    }
});
